function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "contacts-import",
  transform: "translate(-1081.000000, -285.000000)",
  fill: "#3A559F",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "import",
  transform: "translate(803.000000, 184.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "platform-buttons",
  transform: "translate(50.000000, 82.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "button-facebook",
  transform: "translate(202.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-facebook",
  transform: "translate(26.000000, 19.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.2845158,0.00749040292 L13.7272797,0 C8.60738132,0 5.29867806,3.47741956 5.29867806,8.85964858 L5.29867806,12.9445398 L0.716581039,12.9445398 C0.320633455,12.9445398 0,13.2733685 0,13.6789738 L0,19.5975157 C0,20.003121 0.320999057,20.3315752 0.716581039,20.3315752 L5.29867806,20.3315752 L5.29867806,35.2659405 C5.29867806,35.6715458 5.61931151,36 6.0152591,36 L11.9935923,36 C12.3895399,36 12.7101734,35.6711713 12.7101734,35.2659405 L12.7101734,20.3315752 L18.0677134,20.3315752 C18.463661,20.3315752 18.7842945,20.003121 18.7842945,19.5975157 L18.7864881,13.6789738 C18.7864881,13.4842233 18.7108084,13.2977123 18.5766322,13.1598889 C18.4424561,13.0220655 18.2596548,12.9445398 18.0695415,12.9445398 L12.7101734,12.9445398 L12.7101734,9.48172654 C12.7101734,7.81735901 13.0973465,6.97244156 15.2138198,6.97244156 L18.2837846,6.971318 C18.6793665,6.971318 19,6.64248931 19,6.23725851 L19,0.741549889 C19,0.336693611 18.6797321,0.00823944321 18.2845158,0.00749040292 Z",
  id: "Path"
})))))));

function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "36px",
    viewBox: "0 0 19 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.800b5e8d.svg";
export { ForwardRef as ReactComponent };